import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaCheckCircle, FaTimesCircle, FaTimes } from "react-icons/fa";
import Header from "../Components/Header";
import Pagetitle from "../Components/Pagetitle";
import Footer from "../Components/Footer";
import { getData, postData } from "../Api";

const ProfilePage = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("success");
  const [user, setUser] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    address: "",
    phone: "",
    city: "",
    state: "",
    pincode: "",
    landmark: "",
    password: "",
    password_confirmation: "",
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (storedUser && storedUser.phone) {
      setUser(storedUser);
      fetchProfile(storedUser.phone);
    } else {
      navigate("/login");
    }
  }, [navigate]);

  const fetchProfile = async (phone) => {
    try {
      const response = await getData(`/my-profile/${phone}`);

      if (response.success) {
        setFormData({
          name: response.data.name || "",
          email: response.data.email || "",
          address: response.data.address || "",
          phone: response.data.phone || "",
          city: response.data.city || "",
          state: response.data.state || "",
          pincode: response.data.pincode || "",
          landmark: response.data.landmark || "",
          password: "",
          password_confirmation: "",
        });
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    } finally {
      setLoading(false);
    }
  };

  const updateProfile = async () => {
    try {
      const response = await postData(`/update-profile`, formData);

      if (response.success) {
        localStorage.setItem("user", JSON.stringify(response.user));
        setUser(response.user);

        setFormData((prev) => ({
          ...prev,
          password: "",
          password_confirmation: "",
        }));

        setModalMessage("Profile updated successfully!");
        setModalType("success");
        setShowModal(true);
      } else {
        const errorMsg = response.errors
          ? Object.values(response.errors).flat().join("\n")
          : "Failed to update profile!";
        setModalMessage(errorMsg);
        setModalType("error");
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error updating profile:", error);

      setModalMessage("Something went wrong while updating your profile.");
      setModalType("error");
      setShowModal(true);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    updateProfile();
  };

  const closeModal = () => {
    setShowModal(false);
  };

  if (!user) return null;

  return (
    <main className="container-fluid">
      <Header />
      <Pagetitle />
      <div className="container my-5">
        {loading ? (
          <p className="text-center">Loading profile...</p>
        ) : (
          <div className="row justify-content-center">
            <div className="col-lg-8 border p-4">
              <div className="text-center mb-4">
                <h3>{user.name}</h3>
                <p className="text-muted">{user.email}</p>
                <hr />
              </div>
              <form className="row" onSubmit={handleSubmit}>
                <div className="col-md-6 mb-3 text-start">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6 mb-3 text-start">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6 mb-3 text-start">
                  <label className="form-label">Phone</label>
                  <input
                    type="text"
                    className="form-control"
                    name="phone"
                    value={formData.phone}
                    readOnly
                  />
                </div>
                <div className="col-md-6 mb-3 text-start">
                  <label className="form-label">Address</label>
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6 mb-3 text-start">
                  <label className="form-label">City</label>
                  <input
                    type="text"
                    className="form-control"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6 mb-3 text-start">
                  <label className="form-label">State</label>
                  <input
                    type="text"
                    className="form-control"
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6 mb-3 text-start">
                  <label className="form-label">Pincode</label>
                  <input
                    type="text"
                    className="form-control"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6 mb-3 text-start">
                  <label className="form-label">Landmark</label>
                  <input
                    type="text"
                    className="form-control"
                    name="landmark"
                    value={formData.landmark}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-12 my-2">
                  <h4>Password Change</h4>
                </div>
                <div className="col-md-6 mb-3 text-start">
                  <label className="form-label">New Password</label>
                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6 mb-3 text-start">
                  <label className="form-label">Confirm New Password</label>
                  <input
                    type="password"
                    className="form-control"
                    name="password_confirmation"
                    value={formData.password_confirmation}
                    onChange={handleChange}
                  />
                </div>
                <button type="submit" className="btn-style1 w-100">
                  Save Changes
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content py-md-4 py-3 px-3 rounded-5 position-relative text-center">
              {/* Close Icon */}
              <button
                type="button"
                className="btn-close position-absolute top-0 end-0 m-3"
                onClick={closeModal}
                aria-label="Close"
              ></button>

              <div className="modal-body">
                <div className="popup-icon mb-3">
                  {modalType === "success" ? (
                    <FaCheckCircle size={60} color="green" />
                  ) : (
                    <FaTimesCircle size={60} color="red" />
                  )}
                </div>
                <h5>{modalMessage}</h5>
              </div>
              <div className="text-center pb-3">
                <button
                  type="button"
                  className="btn-style1 mt-2"
                  onClick={() => {
                    closeModal();
                    if (modalType === "success") {
                      navigate("/");
                    }
                  }}
                >
                  {modalType === "success" ? "Go to Dashboard" : "Close"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </main>
  );
};

export default ProfilePage;
